// extracted by mini-css-extract-plugin
export default {"print":"useStandardPrint_print__Whbhr","mantine-ActionIcon-root":"useStandardPrint_mantine-ActionIcon-root__qHVox"};